import * as React from "react";
import { createBrowserRouter } from "react-router-dom";
import HomePage from "./components/pages/home";

const router = createBrowserRouter([
    {
        path: "/",
        element: <HomePage />,
    },
]);

export default router;